import { createSlice, Slice } from "@reduxjs/toolkit";
import { submitContacts } from "../../actions/submit-contacts.action.ts";
import { submitContactsReducer } from "./reducers/submit-contacts.reducer.ts";
import { setIsWebsocketConnectedReducer } from "./reducers/websocket.reducer.ts";
import setSessionStateReducer from "./reducers/set-session-state.reducer.ts";
import setSessionState from "../../actions/set-session-state.action.ts";
import { SessionStateEnum } from "../../../orchestrator-api-client";
import initStore from "../../actions/init-store.action.ts";
import initStoreReducer from "./reducers/init-store.reducer.ts";
import setClosedSession from "../../actions/set-closed-session.action.ts";
import setClosedSessionReducer from "./reducers/set-closed-session.reducer.ts";
import { setTokenReducer } from "./reducers/set-token-reducer.ts";
import { setKeepAliveReducer } from "./reducers/set-keep-alive.reducer.ts";
import { setFirstSessionReducer } from "./reducers/set-first-session.reducer.ts";
import {
  clearQueueReducer,
  setWsEventQueueReducer,
} from "./reducers/set-ws-event-queue.reducer.ts";
import { setLastAckReducer } from "./reducers/set-last-ack.reducer.ts";

export interface SessionState {
  token: string | undefined;
  keepAlive: boolean;
  isFirstSession: boolean;
  isWebsocketConnected: boolean;
  isClosedByServer: boolean;
  state: SessionStateEnum;
  wsEventsQueue: Array<SessionStateEnum>;
  lastAck: string | undefined;
}

const initialState: SessionState = {
  token: undefined,
  isFirstSession: false,
  keepAlive: false,
  isWebsocketConnected: false,
  isClosedByServer: false,
  state: SessionStateEnum.Init,
  wsEventsQueue: [],
  lastAck: undefined,
};

const sessionSlice: Slice<SessionState> = createSlice({
  name: "session",
  initialState,
  reducers: {
    setIsWebsocketConnected: setIsWebsocketConnectedReducer,
    setToken: setTokenReducer,
    setKeepAlive: setKeepAliveReducer,
    setFirstSession: setFirstSessionReducer,
    setWsEventsQueue: setWsEventQueueReducer,
    clearQueue: clearQueueReducer,
    setLastAck: setLastAckReducer,
  },
  extraReducers: (builder) => {
    builder.addCase(initStore.fulfilled, initStoreReducer);
    builder.addCase(setSessionState.fulfilled, setSessionStateReducer);

    builder.addCase(submitContacts.fulfilled, submitContactsReducer);
    builder.addCase(setClosedSession, setClosedSessionReducer);
  },
});

export const {
  setIsWebsocketConnected,
  setWsEventsQueue,
  clearQueue,
  setKeepAlive,
  setFirstSession,
  setLastAck,
} = sessionSlice.actions;

const sessionReducer = sessionSlice.reducer;
export default sessionReducer;
